import { Badge } from "reactstrap";
import Card from "@components/ui-components/card";
import CustomTooltip from "@components/ui-components/tooltip";
import Flex from "@components/ui-components/flex";
import LoadingButton from "@components/ui-components/loading-button";
import { getStatusBadge } from "@src/utility/helpers/utils";
import useDateHandler from "@src/utility/hooks/use-date-handler";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const CardTask = ({ task, handleRowActions }) => {
    const { dateFormatter } = useDateHandler();
    const [isExpanded, setIsExpanded] = useState(false);

    //todo: integrate this task done part
    const isTaskDone = task.status === "done";

    // Toggle expanded state
    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const statusBadge = getStatusBadge(task.status);
    const { t } = useTranslation();
    return (
        <Card
            children={
                <div className={`bg-light-${statusBadge.color} rounded-2 card-task`}>
                    <Flex
                        justify="between"
                        align="center"
                        className="cursor-pointer"
                        onClick={toggleExpand}>
                        <Flex className="task-title-section font-medium-3">
                            <i
                                className={
                                    isTaskDone ? "mdi mdi-check-circle-outline" : "mdi mdi-radiobox-blank"
                                }
                                id={`task-${task.id}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (!isTaskDone) handleRowActions(task, "markDone");
                                }}/>
                            {!isTaskDone && (
                                <CustomTooltip
                                    target={`task-${task.id}`}
                                    content="Mark as Done"/>
                            )}

                            <span className={`text-${statusBadge.color}`}>{task.name}</span>
                        </Flex>
                        <Flex align="center">
                            <LoadingButton
                                color="info"
                                icon="pencil"
                                subject="companies"
                                action="update"
                                outline
                                onClick={() => {
                                    handleRowActions(task, "edit");
                                }}/>
                            <LoadingButton
                                color="danger"
                                icon="delete"
                                subject="companies"
                                action="delete"
                                outline
                                onClick={() => {
                                    handleRowActions(task, "delete");
                                }}/>
                        </Flex>
                    </Flex>

                    {/* Task Details */}
                    {isExpanded && (
                        <Flex className="text-black border-top mt-2 pt-2" justify="between">
                            <div className="task-info mb-50">
                                <h4 className="fw-bold">{t("Assigned To")}:</h4>
                                <div className="info-value">
                                    {task.assignedTo?.name || "Unknown User"}
                                </div>
                            </div>
                            <div className="task-info mb-50">
                                <h4 className="fw-bold">{t("Due Date")}:</h4>
                                <div className="info-value">
                                    {dateFormatter({
                                        date: task.dueDate
                                    })}
                                </div>
                            </div>
                            <div className="task-info mb-50">
                                <h4 className="fw-bold">{t("Status")}:</h4>
                                <div className="info-value">
                                    {<Badge color={statusBadge.color}>{statusBadge.title}</Badge>}
                                </div>
                            </div>
                            <div className="task-info mb-50">
                                <h4 className="fw-bold">{t("Created")}:</h4>
                                <div className="info-value">
                                    {task.createdAt ? dateFormatter({ date: task.createdAt }) : "Unknown"}
                                </div>
                            </div>
                        </Flex>
                    )}
                </div>
            }/>
    );
};

export default CardTask;
